<template>
  <div class="round-case pa-1" :class="{opened}">
    <v-tooltip :disabled="noTooltip" top content-class="rounded-0 pa-0" color="grey300">
      <template #activator="{ on }">
        <v-img
          contain class="flex-grow-0" :width="crateSize" :src="caseImage"
          :aspect-ratio="1" v-on="on"
        />
      </template>
      <div class="grey300">
        <div class="pa-2 text-center">
          <h4 class="text-body-2 font-weight-semibold" v-text="gameCase.name" />
          <scrap class="text-caption" :amount="gameCase.price" />
        </div>

        <h4 class="text-caption px-2 py-1 grey400 faded-8">
          <fai :icon="['fas', 'info-circle']" class="blue200--text mr-1" />
          Right-click for info
        </h4>
      </div>
    </v-tooltip>

    <div v-if="gameCase.amount" class="amount d-flex align-center justify-center rounded-circle">
      <span class="text-body-2 font-weight-semibold"> {{ gameCase.amount }}x</span>
    </div>
  </div>
</template>

<script>
const defaultCaseImg = require('@/assets/img/games/cases/default-case.png')

export default {
  props: {
    gameCase: {
      type: Object,
      required: true,
    },
    crateSize: {
      type: Number,
      required: true,
    },
    opened: Boolean,
    noTooltip: Boolean,
  },
  computed: {
    caseImage() {
      return this.gameCase?.imageUrl || defaultCaseImg
    },
  },
}
</script>

<style lang="scss" scoped>
.round-case {
  position: relative;
  transition: opacity 0.5s ease, transform 0.5s ease;
  will-change: transform, opacity;
}

.amount {
  position: absolute;
  right: 0;
  bottom: 6px;
  width: 1.75em;
  height: 1.75em;
  background: rgba(#6e6b65, 0.55);
  pointer-events: none;

  span {
    line-height: 1 !important;
  }
}

.opened {
  opacity: 0.5;
  transform: scale(0.8);
}
</style>
